import { FormControl, FormControlProps } from "@mui/material";
import { styled } from "@mui/material/styles";

export const OCFormControl: React.FC<FormControlProps> = styled((props: FormControlProps) => (
  <FormControl {...props} />
))(({ theme }) => ({
  ".MuiFormLabel-root": {
    padding: "4px 10px",
    fontSize: "0.8rem",
    color: `${theme.custom.forms.labels} !important`,
  },
}));
